import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import Vue from 'vue';
import App from './App.vue';
import DashboardLayout from './layouts/Dashboard.vue';
import DashboardRTLLayout from './layouts/DashboardRTL.vue';
import DefaultLayout from './layouts/Default.vue';
import router from './router';
import './scss/app.scss';
import store from './store';
import Axios from "axios";
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap and BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
/* axios */
window.axios = Axios;
// axios.defaults.baseURL = 'http://127.0.0.1:8040/api/admin';
//axios.defaults.baseURL = 'https://api.aatcart.com/api/admin';
 axios.defaults.baseURL = 'https://api.stage.aatcart.com/api/admin';

if (localStorage.token) {
axios.defaults.headers.common['Authorization'] = "Bearer " + localStorage.token;
}
axios.defaults.headers.post['Accept'] = 'application/json';
axios.defaults.headers.post['Content-Type'] = 'application/json';
/* axios */

/* toast */
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

const options = {
position: "top-right",
timeout: 5000,
closeOnClick: false,
pauseOnFocusLoss: true,
pauseOnHover: true,
draggable: true,
draggablePercent: 0.6,
showCloseButtonOnHover: true,
hideProgressBar: true,
closeButton: "button",
icon: true,
rtl: true
};
Vue.use(Toast, options);
Vue.use(Antd);
Vue.config.productionTip = false

/* persian datetime piker*/

import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
Vue.component('date-picker', VuePersianDatetimePicker);
Vue.use(VuePersianDatetimePicker, {
name: 'custom-date-picker',
props: {
format: 'YYYY-MM-DD HH:mm',
displayFormat: 'jYYYY/jMM/jDD ',
editable: false,
inputClass: 'form-control my-custom-class-name',
placeholder: 'لطفا تاریخ را وارد کنید .',
altFormat: 'YYYY-MM-DD HH:mm',
color: '#00acc1',
autoSubmit: true,
//...
//... And whatever you want to set as default.
//...
}
});
// Adding template layouts to the vue components.
Vue.component("layout-default", DefaultLayout);
Vue.component("layout-dashboard", DashboardLayout);
Vue.component("layout-dashboard-rtl", DashboardRTLLayout);


/* sweet alert */
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.use(VueSweetalert2);

/* leaflet */

import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import "leaflet-geosearch/dist/geosearch.css";
Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
import { Icon } from 'leaflet';
import {isNullOrUndef} from "chart.js/helpers";

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
iconUrl: require('leaflet/dist/images/marker-icon.png'),
shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});
/* leaflet */


new Vue({
store,
router,
computed:{
 
},
methods: {
handleAxiosError(err) {
let _this = this;
let data = err.response.data;
let status = err.response.status;
if (status == 422) {
let errors = data.errors;
let index = 0;
for (const key in errors) {
const element = errors[key][0];
setTimeout(() => {
_this.$toast.error(element);
}, 500 * index);
index++;
}
} else if (status == 401) {
_this.refreshToken();
}
else if (status == 403) {
_this.$toast.warning("کاربر گرامی ، شما به این بخش دسترسی ندارید.");
location.href='/dashboard';
} else {
console.log("Error with code: " + status);
}

},

async refreshToken(){
let _this = this;
await axios
.post("/refresh", {
refresh_token:localStorage.refresh
})
.then(function (response) {
const data=response.data;
_this.$store.commit('isLogin',data);
_this.me();
location.href = "/dashboard";
})
.catch(function (err) {
_this.$store.commit('logout');
_this.$toast.warning("کاربر گرامی لطفا اطلاعات ورود را وارد کنید.");
});
},
number_format(x) {
if(x=== undefined || x == null){
return '';
}
return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' ریال' ;
},
image_concat(url) {
return 'https://api.aatcart.com/'+url ;
},
full_name(name,family) {
    let fname=isNullOrUndef(name) ? '' : name;
    let lname=isNullOrUndef(family) ? '' : family;
  return fname+' '+lname ;
  },
  
itemRender(current, type, originalElement) {
if (type === "prev") {
return (
<a>
    <a-icon type="right" />
</a>
);
} else if (type === "next") {
return (
<a>
    <a-icon type="left" />
</a>
);
}
return originalElement;
},

async me(){
    let _this = this;
    await axios
      .get("/me")
      .then(function (response) {

        _this.$store.commit('me',response.data);
        
        // location.reload();

        
      })
      .catch(function (err) {
        _this.$root.handleAxiosError(err);
      });
  },
  hasPermission(seg) {
    const segments=seg.split("/")
    const permissions=JSON.parse(localStorage.permissions);
    const seg1=permissions.hasOwnProperty(segments[1]);
    if(seg1 && permissions[segments[1]].hasOwnProperty(segments[2])){
      return true;
    }
      return false;
    
    },

perisan2latin(str){

var persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g,/,/g];
var arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g,/''/g];

if(typeof str === 'string')
{
for(var i=0; i<10; i++) { str=str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i); } } return str; } },
    render: h=> h(App)
    }).$mount('#app')
